/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type ContractsControllerListV1SortBy = typeof ContractsControllerListV1SortBy[keyof typeof ContractsControllerListV1SortBy];


export const ContractsControllerListV1SortBy = {
  recent: 'recent',
  ref: 'ref',
  title: 'title',
  startDate: 'startDate',
  endDate: 'endDate',
  status: 'status',
  updated: 'updated',
} as const;
